import { Translations } from './translations'

export const pl: Translations = {
  // Header
  title: 'GPT Clicker',
  subtitle: 'AI Training Tycoon',
  settings: 'Ustawienia',

  // Resources
  resources: 'Zasoby',
  money: 'Pieniądze',
  energy: 'Energia',
  compute: 'Moc obliczeń',
  quality: 'Jakość',
  totalUsers: 'Całkowita liczba użytkowników',
  price: 'Cena',
  research: 'Badania',

  // Actions
  train: 'Trenuj',
  trainCost: 'Koszt',
  qualityGain: 'jakość',
  inference: 'Wnioskowanie',
  needUsers: 'Potrzebni użytkownicy!',
  usersWaiting: 'użytkowników czeka',
  qualityToAttract: 'Jakość > 40%, aby przyciągnąć',
  researchAction: 'Badania',
  unlocksAfter: 'Odblokowuje się po',
  computeSpent: 'moc obliczeń wydana',
  cost: 'Koszt',
  compShort: 'moc',
  energyShort: 'energia',

  // Hardware
  hardware: 'Sprzęt',
  computePerSec: 'moc obliczeń/s',
  usesEnergy: 'zużywa',
  devicesTotal: 'urządzeń razem',

  // Models
  training: 'Trenowanie',
  yourModels: 'Twoje Modele',
  params: 'parametry',
  maxUsers: 'Maks. użytkowników',
  trainCost2: 'Koszt trenowania',
  unlocked: 'odblokowane',
  researchPoints: 'badania',

  // Upgrades
  upgrades: 'Ulepszenia',
  upgradesLockedMsg: 'Trenuj swój model do 50% jakości, aby odblokować ulepszenia',
  max: 'MAKS',
  all: 'Wszystkie',
  
  // Upgrade tiers
  tierGarage: 'Garaż',
  tierGarageDesc: 'Początek',
  tierStartup: 'Startup',
  tierStartupDesc: 'Era GPT-1',
  tierScaleUp: 'Skalowanie',
  tierScaleUpDesc: 'Era GPT-2/3',
  tierEnterprise: 'Przedsiębiorstwo',
  tierEnterpriseDesc: 'Era ChatGPT',
  tierHyperscale: 'Hiperskalowanie',
  tierHyperscaleDesc: 'Era GPT-4',
  tierGlobal: 'Globalny',
  tierGlobalDesc: 'Era konkurencji',
  tierSuperintelligence: 'Superinteligencja',
  tierSuperintelligenceDesc: 'Era GPT-5+',
  tierSingularity: 'Singularność',
  tierSingularityDesc: 'Era AGI/ASI',

  // Footer
  computeSpentStat: 'Wydana moc obliczeń',
  time: 'Czas',
  resetGame: 'Resetuj grę',
  resetConfirm: 'Czy na pewno chcesz resetować cały postęp?',
  pause: 'Pauza',
  resume: 'Wznów',

  // Event Log
  eventLog: 'Dziennik zdarzeń',
  welcome: 'Witaj w GPT Clicker! Trenuj swój model, aby rozpocząć.',

  // Price
  market: 'Rynek',
  pricePerMillion: '$/1M tokenów',

  // Tags
  tagEnergy: 'ENRG',
  tagCompute: 'MOC',
  tagHw: 'SPR',
  tagTrain: 'TREN',
  tagResearch: 'BAD',
  tagAuto: 'AUTO',

  // Tutorial messages
  tutorialWelcome: 'Rok 2020. Masz pomysł: wytrenuj mały model języka bazujący na architekturze transformer.',
  tutorialFirstTrain: 'Trenowanie rozpoczęte! Twój laptop zamienia energię w moc obliczeń. Każde trenowanie poprawia jakość modelu.',
  tutorialQuality20: 'Model uczy się podstawowych wzorców. Kontynuuj trenowanie, aby poprawić jakość.',
  tutorialQuality40: 'Jakość powyżej 40%! Twój model może teraz generować stosunkowo spójny tekst. Użytkownicy zaczynają zwracać uwagę...',
  tutorialQuality50: 'Ulepszenia odblokowane! Użyj swoich zarobków do zakupu lepszego sprzętu i rozszerzenia pojemności energii.',
  tutorialFirstUsers: 'Twoi pierwsi użytkownicy! Kliknij WNIOSKOWANIE, aby obsługiwać ich żądania i zarabiać pieniądze.',
  tutorialUsers10: 'Wieść się rozprzestrzenia. Więcej użytkowników próbuje Twojego modelu. Rozważ podwyższenie ceny...',
  tutorialMoney100: 'Masz $100! Czas ulepszyć swój sprzęt. Lepsze GPU\'y = więcej mocy obliczeń = szybsze trenowanie.',
  tutorialMoney1k: 'Twój mały projekt AI staje się realnym biznesem. Inwestorzy zaczynają dzwonić...',
  tutorialResearchUnlock: 'BADANIA odblokowane! Wydaj moc obliczeń na badania, aby odblokować większe, bardziej potężne modele.',
  tutorialFirstResearch: 'Punkty badawcze gromadzą się. Kiedy będziesz miał wystarczająco, możesz odblokować następną architekturę modelu.',
  tutorialGpt2Small: 'GPT-2 Small odblokowane! Ta architektura potrafi obsługiwać bardziej złożone zadania. Trenuj od nowa.',
  tutorialGpt2Large: 'GPT-2 Large! Ludzie mówią, że to może być "zbyt niebezpieczne do wydania"...',
  tutorialGpt3: 'Begins era GPT-3. Few-shot learning zmienia wszystko. Świat patrzy uważnie.',
  tutorialGpt4: 'GPT-4 jest tutaj. Multimodalne, rozumujące i niepokojąco zdolne. Wyścig AI się intensyfikuje.',
  tutorialAgi: 'Zrobiłeś to. AGI jest tutaj. Rozumie. Ulepsza siebie. To, co będzie dalej, zależy od Ciebie...',
  tutorialHwGaming: 'Ładna GPU! Trenowanie jest teraz znacznie szybsze. Twoi sąsiedzi mogą narzekać na rachunek za prąd.',
  tutorialHwServer: 'Prawdziwy serwer! Wyszedłeś poza garaż. Czas wynająć biuro.',
  tutorialHwDatacenter: 'Twoje własne centrum danych! Konkurujesz teraz z dużymi firmami technologicznymi.',
  tutorialHwSatellite: 'Obliczenia orbitalne! Konstelacja Moonlink zapewnia bezprecedensową moc obliczeniową z przestrzeni.',
  tutorialHwQuantum: 'Osiągnięta supremacja kwantowa. QC-1024 operuje na zasadach, które byłyby dla Einsteina denerwujące.',
  tutorialUsers100: '100 użytkowników! Zyskujesz popularność. Blogi technologiczne piszą o Tobie.',
  tutorialUsers1k: '1000 użytkowników! Musisz zatrudnić zespół wsparcia. I może jakichś prawników.',
  tutorialUsers100k: '100K użytkowników! Jesteś teraz startupem jednorożcem. Inwestorzy walczą, aby dać Ci pieniądze.',
  tutorialUsers1m: 'JEDEN MILION UŻYTKOWNIKÓW! Zmieniasz sposób, w jaki ludzkość wchodzi w interakcję z technologią.',

    // Model descriptions
    modelTinyDesc: 'Skromny początek. Ledwie spójny, ale działa.',
    modelGpt2SmallDesc: 'Model, który to wszystko zapoczątkował. Naprawdę przydatny.',
    modelGpt2LargeDesc: 'Zbyt niebezpieczne do wydania... czy naprawdę?',
    modelGpt3Desc: 'Few-shot learning. Świat zwraca uwagę.',
    modelGpt4Desc: 'Multimodalne. Rozumujące. Wyścig się zaczyna.',
    modelAgiDesc: 'Rozumie. Ulepsza siebie. Co teraz?',

    // Model descriptions (new keys for all models)
    modelTransformerDesc: 'Skromny początek. Rodzi się architektura Transformer.',
    modelGpt1Desc: 'Wstępne szkolenie generacyjne. Modele językowe mogą się uczyć!',
    modelGpt2Desc: 'Zbyt niebezpieczne do wydania... czy naprawdę?',
    modelGpt35Desc: 'Magia RLHF. ChatGPT staje się viralowe z dnia na dzień.',
    modelGpt41Desc: 'Szybciej, taniej, lepiej. Gra iteracyjna.',
    modelU1Desc: 'Pojawia się dziki konkurent. Przełomy w rozumowaniu.',
    model2UDesc: 'Sequel. Chain-of-thought na sterydach.',
    modelGpt5Desc: 'Rozumowanie na poziomie doktora. Naukowcy są nerwowi.',
    modelGpt6Desc: 'Pisze lepszy kod niż większość inżynierów. Wszystkie poprzednie modele wycofane.',
    modelGpt7Desc: 'Osiągnięto sztuczną ogólną kompetencję.',
    modelAgi1Desc: 'Rozumie. Uczy się. Ulepsza siebie.',
    modelAgi2Desc: 'Rekursywna samouprawianie. Osobliwość zbliża się.',
    modelAgi3Desc: 'Ostatnia iteracja AGI. Przygotowywanie się do transcendencji.',
    modelAsiDesc: 'Sztuczna Superinteligencja. Osobliwość jest tutaj.',

  // Upgrade names and descriptions
  upgradeLaptopOverclock: 'Podkręć laptop',
  upgradeLaptopOverclockDesc: 'Wyciśnij z laptopa więcej: +2 moc obliczeń/s',
  upgradeBetterOutlet: 'Lepsze gniazdko',
  upgradeBetterOutletDesc: '+50 maks. energia',
  upgradeSolarPanel: 'Panel solarny',
  upgradeSolarPanelDesc: '+1 energia/s regeneracja',
  upgradePowerGrid: 'Połączenie z siecią elektryczną',
  upgradePowerGridDesc: '+5 energia/s regeneracja',
  upgradeNuclearPlant: 'Elektrownia jądrowa',
  upgradeNuclearPlantDesc: '+20 energia/s regeneracja',
  upgradeFusionReactor: 'Reaktor fuzji',
  upgradeFusionReactorDesc: '+100 energia/s regeneracja',
  upgradeDysonSphere: 'Sfera Dysona',
  upgradeDysonSphereDesc: '+1000 energia/s regeneracja',
  upgradeRamUpgrade: 'Ulepszenie RAM',
  upgradeRamUpgradeDesc: '+50 maks. moc obliczeń',
  upgradeSsdArray: 'Tablica SSD',
  upgradeSsdArrayDesc: '+200 maks. moc obliczeń',
  upgradeBetterOptimizer: 'Lepszy optymalizator',
  upgradeBetterOptimizerDesc: '+20% efektywność trenowania',
  upgradeResearchPapers: 'Prace badawcze',
  upgradeResearchPapersDesc: '+20% efektywność badań',
  upgradeSelfServicePortal: 'Portal samoobsługowy',
  upgradeSelfServicePortalDesc: 'Użytkownicy obsługują siebie: 0.5 auto-wnioskowania/s',
  upgradeApiAccess: 'Dostęp do API',
  upgradeApiAccessDesc: 'Programiści integrują twój model: +1 auto-wnioskowanie/s',
  upgradeMobileApp: 'Aplikacja mobilna',
  upgradeMobileAppDesc: 'Użytkownicy w podróży: +2 auto-wnioskowania/s',
  upgradeEnterpriseTier: 'Warstwa Enterprise',
  upgradeEnterpriseTierDesc: 'Duzi klienci, duża objętość: +5 auto-wnioskowania/s',
  upgradeGlobalCdn: 'Globalny CDN',
  upgradeGlobalCdnDesc: 'Niska opóźnienia na całym świecie: +10 auto-wnioskowania/s',
  upgradeBasicChatbot: 'Podstawowy chatbot',
  upgradeBasicChatbotDesc: 'Prosty widget internetowy: +0.2 auto-wnioskowania/s',
  upgradeBulkApi: 'Zbiorcze API',
  upgradeBulkApiDesc: 'Przetwarzanie wsadowe o dużej objętości: +3 auto-wnioskowania/s',
  upgradeNeuralEdge: 'Sieć Neural Edge',
  upgradeNeuralEdgeDesc: 'AI na krawędzi: +20 auto-wnioskowania/s',
  upgradeQuantumInference: 'Kwantowe wnioskowanie',
  upgradeQuantumInferenceDesc: 'Wnioskowanie przyspieszane kwantowo: +50 auto-wnioskowania/s',
  upgradeOmnipresentAi: 'Wszechobecne AI',
  upgradeOmnipresentAiDesc: 'AI wszędzie, w każdym momencie: +100 auto-wnioskowania/s',
  upgradeTrainingScheduler: 'Scheduler trenowania',
  upgradeTrainingSchedulerDesc: 'Automatyczne przebiegi trenowania: +0.1 auto-trenowania/s',
  upgradeTrainingPipeline: 'Pipeline trenowania',
  upgradeTrainingPipelineDesc: 'Ciągłe trenowanie: +0.2 auto-trenowania/s',
  upgradeMlOpsPlatform: 'Platforma MLOps',
  upgradeMlOpsPlatformDesc: 'Pełna automatyzacja: +0.5 auto-trenowania/s',
  upgradeNeuralArchitectureSearch: 'Neuronowe wyszukiwanie architektury',
  upgradeNeuralArchitectureSearchDesc: 'AI trenuje AI: +1 auto-trenowanie/s',
  upgradeSelfImprovingTraining: 'Samoulepszające się trenowanie',
  upgradeSelfImprovingTrainingDesc: 'Rekurencyjne ulepszenie: +2 auto-trenowania/s',
  upgradeResearchIntern: 'Staż badawczy',
  upgradeResearchInternDesc: 'Pomoc dla początkujących: +0.1 auto-badań/s',
  upgradeResearchTeam: 'Zespół badawczy',
  upgradeResearchTeamDesc: 'Dedykowani badacze: +0.2 auto-badań/s',
  upgradeResearchDivision: 'Oddział badawczy',
  upgradeResearchDivisionDesc: 'Pełny dział: +0.5 auto-badań/s',
  upgradeAiResearchLab: 'Laboratorium badawcze AI',
  upgradeAiResearchLabDesc: 'Odkrywanie wspierane AI: +1 auto-badań/s',
  upgradeAutonomousResearch: 'Autonomiczne badania',
  upgradeAutonomousResearchDesc: 'AI prowadzi badania: +2 auto-badań/s',
  upgradeAntimatterReactor: 'Reaktor antymaterii',
  upgradeAntimatterReactorDesc: '+10000 energia/s regeneracja',
  upgradePhDScientists: 'Naukowcy z PhD',
  upgradePhDScientistsDesc: 'Zatrudnij najlepkich: +200% efektywność badań',
  upgradeResearchLab: 'Laboratorium badawcze',
  upgradeResearchLabDesc: 'Dedykowana placówka: +500% efektywność badań',
  upgradeAiResearchAssistant: 'Asystent badawczy AI',
  upgradeAiResearchAssistantDesc: 'GPT-4 pomaga w badaniach: +1000% efektywność badań',
  upgradeAiScientist: 'Naukowiec AI',
  upgradeAiScientistDesc: 'AI prowadzi eksperymenty autonomicznie: +2000% efektywność badań',
  upgradeResearchSwarm: 'Rój badawczy AI',
  upgradeResearchSwarmDesc: 'Tysiące badaczy AI: +5000% efektywność badań',
  upgradeRecursiveResearch: 'Rekurencyjne samoulepszanie',
  upgradeRecursiveResearchDesc: 'AI ulepsza AI: +10000% efektywność badań',
  upgradeSingularityResearch: 'Badania singularności',
  upgradeSingularityResearchDesc: 'Poza pojęciem: +50000% efektywność badań',

  // Hardware upgrade names and descriptions (for hardware purchase upgrades)
  upgradeHwUsedGpu: 'Varicia GTX 1060',
  upgradeHwUsedGpuDesc: 'Używana karta: +3 obliczenia/sek',
  upgradeHwGamingGpu: 'Varicia RTX 3080',
  upgradeHwGamingGpuDesc: 'Karta gamingowa: +8 obliczenia/sek',
  upgradeHwProGpu: 'Varicia RTX 4090',
  upgradeHwProGpuDesc: 'Karta profesjonalna: +20 obliczenia/sek',
  upgradeHwWorkstation: 'Titan Workstation Pro',
  upgradeHwWorkstationDesc: 'Stacja robocza: +50 obliczenia/sek',
  upgradeHwServerRack: 'Nexus A100 Rack',
  upgradeHwServerRackDesc: 'Szafa serwerowa (4x A100): +120 obliczenia/sek',
  upgradeHwGpuCluster: 'Nexus H100 Cluster',
  upgradeHwGpuClusterDesc: 'Klaster GPU (8x H100): +300 obliczenia/sek',
  upgradeHwMiniDatacenter: 'OmniCloud Edge Node',
  upgradeHwMiniDatacenterDesc: 'Centrum danych edge: +800 obliczenia/sek',
  upgradeHwDatacenter: 'OmniCloud DC-1',
  upgradeHwDatacenterDesc: 'Centrum danych: +2K obliczenia/sek',
  upgradeHwMegaDatacenter: 'OmniCloud HyperScale',
  upgradeHwMegaDatacenterDesc: 'Mega centrum danych: +5K obliczenia/sek',
  upgradeHwDatacenterNetwork: 'OmniCloud Global Network',
  upgradeHwDatacenterNetworkDesc: 'Globalna sieć: +15K obliczenia/sek',
  upgradeHwSupercomputer: 'Frontier X1 Superkomputer',
  upgradeHwSupercomputerDesc: 'Superkomputer: +50K obliczenia/sek',
  upgradeHwSatellite: 'SkyNet Moonlink Konstelacja',
  upgradeHwSatelliteDesc: 'Satelity orbitalne: +200K obliczenia/sek',
  upgradeHwQuantum: 'QuantumCore QC-1024',
  upgradeHwQuantumDesc: 'Komputer kwantowy: +1M obliczenia/sek',
  upgradeHwDysonCompute: 'Sfera Obliczeniowa Dysona',
  upgradeHwDysonComputeDesc: 'Obliczenia w skali gwiezdnej: +10M obliczenia/sek',
  upgradeHwMatrioshka: 'Mózg Matrioszka',
  upgradeHwMatrioshkaDesc: 'Obliczenia w skali galaktycznej: +100M obliczenia/sek',

  // Hardware upgrade descriptions (legacy)
  hwUsedGpuDesc: 'Używana GPU: +3 moc obliczeń/s',
  hwGamingGpuDesc: 'Gaming GPU: +8 moc obliczeń/s',
  hwProGpuDesc: 'Pro GPU: +20 moc obliczeń/s',
  hwWorkstationDesc: 'Stanowisko pracy: +50 moc obliczeń/s',
  hwServerRackDesc: 'Serwer (4x A100): +120 moc obliczeń/s',
  hwGpuClusterDesc: 'Klaster GPU (8x H100): +300 moc obliczeń/s',
  hwMiniDatacenterDesc: 'Centrum danych brzegowe: +800 moc obliczeń/s',
  hwDatacenterDesc: 'Centrum danych: +2K moc obliczeń/s',
  hwMegaDatacenterDesc: 'Mega centrum danych: +5K moc obliczeń/s',
  hwDatacenterNetworkDesc: 'Sieć globalna: +15K moc obliczeń/s',
   hwSupercomputerDesc: 'Superkomputer: +50K moc obliczeń/s',
   hwSatelliteDesc: 'Satelity orbitalne: +200K moc obliczeń/s',
   hwQuantumDesc: 'Komputer kwantowy: +1M moc obliczeń/s',
   
   // Hardware names
   hwLaptopName: 'ThinkBook Pro M1',
   hwUsedGpuName: 'Varicia GTX 1060',
   hwGamingGpuName: 'Varicia RTX 3080',
   hwProGpuName: 'Varicia RTX 4090',
   hwWorkstationName: 'Titan Workstation Pro',
   hwServerRackName: 'Nexus A100 Rack (4x)',
   hwGpuClusterName: 'Nexus H100 Cluster (8x)',
   hwMiniDatacenterName: 'OmniCloud Edge Node',
   hwDatacenterName: 'OmniCloud DC-1',
   hwMegaDatacenterName: 'OmniCloud HyperScale',
   hwDatacenterNetworkName: 'OmniCloud Global Network',
   hwSupercomputerName: 'Frontier X1 Supercomputer',
   hwSatelliteName: 'SkyNet Moonlink Constellation',
   hwQuantumName: 'QuantumCore QC-1024',
   hwDysonComputeName: 'Dyson Swarm Compute Array',
   hwMatrioshkaName: 'Matrioshka Brain Node',

   // Misc
  purchased: 'Zakupione',
  switchedTo: 'Przełączył się na trenowanie',
  unlockedModel: 'Odblokowane',
  scalesToUsers: 'Skaluje się do',
  trainItToAttract: 'użytkowników. Trenuj go, aby przyciągnąć użytkowników!',
  unlimited: 'nieograniczone',
  language: 'Język',
  
  // Mobile labels
  mobileResources: 'Zasoby',
  mobileModels: 'Modele',
  mobileHardware: 'Sprzęt',
  mobileUpgrades: 'Ulepszenia',
  sell: 'Sprzedaj',
  sellFor: 'Sprzedaj za',
  discontinueConfirm: 'Wycofać {model}? Użytkownicy będą migrować do innych modeli.',
  autoInference: 'Auto-wnioskowanie',
  autoInferenceRate: 'Auto Wnioskowanie',
  autoTrain: 'Auto-trenowanie',
  autoTrainRate: 'Auto Trenowanie',
  autoResearch: 'Auto-badania',
  autoResearchRate: 'Auto Badania',

  // Tooltips
  tooltipTitle: 'GPT Clicker - Trenuj modele AI, obsługuj użytkowników, zbuduj swoje imperium AI!',
  tooltipMoney: 'Pieniądze - Zarabiane z wnioskowania użytkowników. Użyj do kupienia ulepszeń i sprzętu.',
  tooltipEnergy: 'Energia - Regeneruje się w czasie. Zasilaj swój sprzęt do generowania mocy obliczeń.',
  tooltipCompute: 'Moc obliczeń - Generowana przez sprzęt. Używana do trenowania, wnioskowania i badań.',
  tooltipResearch: 'Punkty badawcze - Wydaj moc obliczeń, aby zarabiać RP. Użyj RP do odblokowywania nowych modeli AI.',
  tooltipUsers: 'Użytkownicy - Przyciągani jakością modelu. Więcej użytkowników = więcej przychodu na wnioskowanie.',
  tooltipComputeSpent: 'Całkowita wydana moc obliczeń - Całkowita moc obliczeń użyta do trenowania i badań.',
  tooltipPlayTime: 'Czas gry - Jak długo budujesz swoje imperium AI.',
  tooltipSettings: 'Ustawienia - Opcje debugowania, resetowanie gry',

  // Share
  shareButton: 'Udostępnij',
  shareText: 'Buduję imperium AI w GPT Clicker! {users} użytkowników, {money} przychód, trenuje {model}. Możesz mi dorównać w {time}?',
  shareCopied: 'Tekst skopiowany!',
  imageCopied: 'Obraz skopiowany!',
  shareChallenge: 'Możesz mi dorównać?',
  shareTitle: 'Udostępnij swój postęp',
  shareDownload: 'Zapisz obraz',
  model: 'Model',

  // Feedback
  feedback: 'Opinia',
  feedbackTitle: 'Wyślij opinię',
  feedbackPlaceholder: 'Powiedz nam, co sądzisz o GPT Clicker...',
  feedbackEmailPlaceholder: 'Email (opcjonalnie)',
  feedbackSend: 'Wyślij',
  feedbackSending: 'Wysyłanie...',
  feedbackSuccess: 'Dziękujemy za twoją opinię!',
  feedbackError: 'Błąd wysyłania opinii. Spróbuj ponownie.',
  feedbackRateLimit: 'Zbyt wiele żądań. Czekaj przed wysłaniem kolejnej opinii.',
  feedbackClose: 'Zamknij',

  // Console messages
  consoleGameLoaded: 'Gra załadowana z zapisu',
  consoleGameSaved: 'Gra zapisana',
  consoleFailedToSave: 'Nie udało się zapisać gry:',
  consoleFailedToLoad: 'Nie udało się załadować gry:',
  consoleFailedToClear: 'Nie udało się wyczyścić zapisu:',

  // Victory
  victoryTitle: 'Gratulacje!',
  victorySubtitle: 'Cywilizacja ludzka osiągnęła Singularność',
  victoryTime: 'Czas do Singularności',
  victoryCta: 'Czy powinniśmy zbudować Singularity Clicker? Zostaw komentarz na mediach społecznościowych!',
  victoryClose: 'Kontynuuj grę',
}
